import { Button, Form, Select, Skeleton } from 'antd'
import { useTranslation } from 'react-i18next'
import { patchFetcher } from '@BUP/services/Axios'
import useSWRMutation from 'swr/mutation'
import styles from './select-form.module.scss'

const SelectForm = ({ labelText, inputName, complaint, mutateGetComplaint, isLoadingComplaint, options, isLoadingUtils }) => {
  const i18n = useTranslation()
  const [form] = Form.useForm()
  const { trigger, isMutating } = useSWRMutation(`/complaints/${complaint.id}`, patchFetcher)

  if (complaint.state === 'closed') return null
  if (!options) return null

  const handleOnFinish = async value => {
    try {
      const updatedValues = { ...value }
      await trigger(updatedValues)
      mutateGetComplaint()
    } catch (error) {
      console.log('Error', error)
    }
  }
  const handleOnConfirm = () => form.submit()

  const handleOnFinishFailed = errorInfo => console.log('Failed:', errorInfo)

  return (
    <Skeleton active loading={isLoadingUtils || isMutating || isLoadingComplaint}>
      <Form
        form={form}
        onFinish={handleOnFinish}
        onFinishFailed={handleOnFinishFailed}
        disabled={isMutating}
        className={styles.form}
      >
        <Form.Item
          name={inputName}
          label={i18n.t(`common.resources.complaint.attributes.${labelText}.label`)}
          rules={[{ required: true, message: i18n.t(`common.resources.complaint.attributes.${labelText}.validations.required`) }]}
          style={{ display: 'inline-block', width: '65%' }}
        >
          <Select
            options={options.map(option => ({ value: option, label: i18n.t(`common.resources.complaint.values.${labelText}.${option}.label`) }))}
          />
        </Form.Item>
        <Form.Item>
          <Button type='primary' onClick={handleOnConfirm}>{i18n.t('common.resources.generic.actions.any.apply')}</Button>
        </Form.Item>
      </Form>
    </Skeleton>
  )
}

export default SelectForm
